import type { IconButtonProps } from '@hulu/react-style-components';
import { IconButton as TrekIconButton } from '@hulu/react-style-components';
import type { FunctionComponent } from 'react';
import React from 'react';

const IconButton: FunctionComponent<IconButtonProps> = (props) => <TrekIconButton as="button" {...props} />;

export default IconButton;
